import { getFirebaseAuth } from "./firebase";
import { signOut } from "firebase/auth";

export async function logout() {
  try {
    const firebaseAuth = getFirebaseAuth();
    if (!firebaseAuth) {
      throw new Error("Firebase auth is not initialized");
    }

    const { auth } = firebaseAuth;

    // Sign out from Firebase Auth
    await signOut(auth);

    // Also clear the session cookie via the API
    await fetch("/api/auth/session", {
      method: "DELETE",
    });

    return { success: true };
  } catch (error: any) {
    console.error("Error signing out:", error);
    return { success: false, error: error.message };
  }
}
